export default {
  body: {
    margin: 0,
    padding: 0,
    fontFamily: 'Avenir Next W01',
  },
  '.icon-link': {
    display: 'none',
  },
  '.with-overlay': {
    overflow: 'hidden',
  },
};
